export const stripFormatting = (value = '') => {
  const parsedValue = parseFloat(value.replace(/[^0-9.]/g, ''));
  return Number.isNaN(parsedValue) ? 0.0 : parsedValue;
};
